<div class="flex flex-col gap-2">
  @if (props.label) {
    <label [for]="id" class="font-semibold">
      {{ props.label }}
      @if (props.required) {
        <span class="text-red-500">*</span>
      }
    </label>
  }
  @if (props.description) {
    <div>
      {{ props.description }}
    </div>
  }

  <div class="flex flex-col gap-5">
    @for (field of field.fieldGroup; track $index) {
      <div class="flex flex-col w-full">
        <div class="flex flex-row w-full justify-between gap-3 items-start" >
          <formly-field class="w-full" [field]="field"></formly-field>
          <p-button class="w-fit h-full" variant="text" severity="danger" (click)="remove($index)" [disabled]="props.disabled">
            <i class="pi pi-trash mt-1" style="font-size: 1.2rem"></i>
          </p-button>
        </div>
        <div class="col-1 d-flex align-items-center"></div>
      </div>
    }
  </div>
  <div class="flex justify-start mt-3">
    <p-button class="w-fit" icon="pi pi-plus" [label]="props['addText']" (click)="add()" [disabled]="props.disabled"/>
  </div>
</div>
